import { NotificationRule } from 'ais-facade-api/api';
import { useTranslation } from 'react-i18next';

type eventTypeT = {
  PORT_LOWER_THE_ANCHOR: string,
  PORT_RAISE_THE_ANCHOR: string,
  AREA_IN: string,
  AREA_OUT: string,
  PORT_ARRIVAL: string,
  PORT_DEPARTURE: string,
}

export const getNotificationEventType = (rule: NotificationRule) => {
  const { t } = useTranslation();

  const eventType = {
    PORT_LOWER_THE_ANCHOR: t('PortArrival'),
    PORT_RAISE_THE_ANCHOR: t('DepartureFromPort'),
    AREA_IN: t('EnteredTheGeozone'),
    AREA_OUT: t('LeftTheGeozone'),
    PORT_ARRIVAL: t('EnteredTheWaterAreaOfPort'),
    PORT_DEPARTURE: t('LeftTheWaterAreaOfPort'),
    ANCHORAGE_IN: 'ANCHORAGE_IN',
    ANCHORAGE_OUT: 'ANCHORAGE_OUT',
    ANCHORAGE_LOWER_THE_ANCHOR: t('Anchoring'),
    ANCHORAGE_RAISE_THE_ANCHOR: t('RemovingFromAnchorage'),
    TARGET_SAFETY: t('EmergencySignals'),
  };

  const typeObject: eventTypeT = eventType;
  return typeObject[rule.eventType as keyof typeof typeObject];
}
